(ns fablo-offers.common.lib.routing
  (:require
   [lambdaisland.glogi :as log]
   [reitit.core :as r]
   [reitit.frontend.easy :as rfe]))

(defn href
  "Returns relative url for given screen-name. Url can be used in HTML links."
  ([screen-name]
   (href screen-name nil nil))
  ([k params]
   (href k params nil))
  ([screen-name params query]
   (rfe/href screen-name params query)))
